import styled from 'styled-components';

import { ITEM_HEIGHT } from '../../../ui/auction-card/AuctionCard';

export const DEFAULT_MAX_COLUMNS = 5;

export const VERTICAL_GAP = 32;

export const ROW_HEIGHT = ITEM_HEIGHT + VERTICAL_GAP;

export const Container = styled.div`
	width: 100%;
`;

export const Content = styled.div<{ $maxWidth: number }>`
	max-width: ${({ $maxWidth }) => `${$maxWidth}px`};
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: ${({ theme }) => `${theme.spacings.xlarge} 0`};
	gap: ${({ theme }) => theme.spacings.xxxsmall};
	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacings.xxxsmall};
	margin-right: ${({ theme }) => theme.spacings.small};
	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		display: flex;
		flex-direction: column;
	}
`;

export const Title = styled.div`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Subtitle = styled.div`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.unselected};
`;

export const AuctionWrapper = styled.div`
	display: flex;
	flex: 1 1 auto;
	width: 100%;
`;
